import { useLayoutEffect, useRef } from 'react';
import { useAppDispatch } from '../../../hooks';
import useNavItems from '../../../hooks/useNavItems';
import { resetFocus } from '../../../reducers/navItems';
const useVerticalNavFocus = ({
  id
}) => {
  const dispatch = useAppDispatch();
  const {
    focusedItem
  } = useNavItems();
  const ref = useRef(null);
  const shouldFocus = focusedItem === id;
  useLayoutEffect(() => {
    if (shouldFocus && ref.current) {
      ref.current.focus();
      dispatch(resetFocus());
    }
  }, [dispatch, shouldFocus]);
  return {
    ref
  };
};
export default useVerticalNavFocus;